/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SystemDropdownParameterResponse } from './SystemDropdownParameterResponse';
import {
    SystemDropdownParameterResponseFromJSON,
    SystemDropdownParameterResponseFromJSONTyped,
    SystemDropdownParameterResponseToJSON,
    SystemDropdownParameterResponseToJSONTyped,
} from './SystemDropdownParameterResponse';
import type { SystemDropdownCategory } from './SystemDropdownCategory';
import {
    SystemDropdownCategoryFromJSON,
    SystemDropdownCategoryFromJSONTyped,
    SystemDropdownCategoryToJSON,
    SystemDropdownCategoryToJSONTyped,
} from './SystemDropdownCategory';

/**
 * 
 * @export
 * @interface SystemDropdownOptionResponse
 */
export interface SystemDropdownOptionResponse {
    /**
     * 
     * @type {string}
     * @memberof SystemDropdownOptionResponse
     */
    id: string;
    /**
     * 
     * @type {SystemDropdownCategory}
     * @memberof SystemDropdownOptionResponse
     */
    category: SystemDropdownCategory;
    /**
     * 
     * @type {string}
     * @memberof SystemDropdownOptionResponse
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof SystemDropdownOptionResponse
     */
    value: string;
    /**
     * 
     * @type {boolean}
     * @memberof SystemDropdownOptionResponse
     */
    isHidden: boolean;
    /**
     * 
     * @type {Array<SystemDropdownParameterResponse>}
     * @memberof SystemDropdownOptionResponse
     */
    parameters: Array<SystemDropdownParameterResponse>;
}



/**
 * Check if a given object implements the SystemDropdownOptionResponse interface.
 */
export function instanceOfSystemDropdownOptionResponse(value: object): value is SystemDropdownOptionResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('isHidden' in value) || value['isHidden'] === undefined) return false;
    if (!('parameters' in value) || value['parameters'] === undefined) return false;
    return true;
}

export function SystemDropdownOptionResponseFromJSON(json: any): SystemDropdownOptionResponse {
    return SystemDropdownOptionResponseFromJSONTyped(json, false);
}

export function SystemDropdownOptionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemDropdownOptionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'category': SystemDropdownCategoryFromJSON(json['category']),
        'key': json['key'],
        'value': json['value'],
        'isHidden': json['isHidden'],
        'parameters': ((json['parameters'] as Array<any>).map(SystemDropdownParameterResponseFromJSON)),
    };
}

export function SystemDropdownOptionResponseToJSON(json: any): SystemDropdownOptionResponse {
    return SystemDropdownOptionResponseToJSONTyped(json, false);
}

export function SystemDropdownOptionResponseToJSONTyped(value?: SystemDropdownOptionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'category': SystemDropdownCategoryToJSON(value['category']),
        'key': value['key'],
        'value': value['value'],
        'isHidden': value['isHidden'],
        'parameters': ((value['parameters'] as Array<any>).map(SystemDropdownParameterResponseToJSON)),
    };
}

